import { render, staticRenderFns } from "./apple.vue?vue&type=template&id=609f6074"
import script from "./apple.vue?vue&type=script&lang=js"
export * from "./apple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports